/** @format */

import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import "../SCSS/stylesMobile.css";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { customFormCompTypes } from "../CustomFormType";

function CustomFormMobileView({
  dispatch,
  isPreview,
  surveyAnswersInfo,
  questionId,
}: customFormCompTypes) {
  return (
    <div className="mobile-custom-form-container">
      <Tippy
        content=" Please add if any files to particular question."
        placement="top-start"
        theme="light"
        disabled={
          isPreview ||
          surveyAnswersInfo.surveyStatus === EnumSurveyAnswerStatus?.COMPLETED
        }
      >
        <div className="mobile-custom-form-cover">
          <>
            <button
              className="mobile-custom-form-gray"
              onClick={() =>
                dispatch({
                  type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                  payload: {
                    toggleState: true,
                    questionId: questionId,
                  },
                })
              }
              disabled={
                isPreview ||
                surveyAnswersInfo.surveyStatus ===
                  EnumSurveyAnswerStatus?.COMPLETED
              }
            >
              Attach File{" "}
            </button>
          </>
        </div>
      </Tippy>
    </div>
  );
}

export default CustomFormMobileView;
